import { uploadFilesToS3 } from '../services/api/implementation/impl';

// The builder's own paperwork on a PO — shared by the accept step and the PO page.
export const PO_DOCUMENT_TYPES = [
  { value: 'bill', label: 'Bill' },
  { value: 'quotation', label: 'Quotation' },
  { value: 'other', label: 'Other' }
];
export const MAX_DOCUMENT_MB = 10;

// Error message for the first file that can't be attached, or null when all are fine.
export const validatePODocumentFiles = (files) => {
  const unsupported = files.find(
    (file) => file.type !== 'application/pdf' && !file.type.startsWith('image/')
  );
  if (unsupported) return `${unsupported.name} is not a PDF or image`;
  const tooBig = files.find((file) => file.size > MAX_DOCUMENT_MB * 1024 * 1024);
  if (tooBig) return `${tooBig.name} is larger than ${MAX_DOCUMENT_MB} MB`;
  return null;
};

// /s3/upload keys objects by file name alone, so two POs uploading "bill.pdf"
// would overwrite each other's file. Upload under a unique, URL-safe key and
// keep the original name for display.
const toUniqueUploadFile = (prefix, file, index) => {
  const safeName = file.name.replace(/[^A-Za-z0-9._-]+/g, '_');
  return new File([file], `${prefix}-${Date.now()}-${index}-${safeName}`, { type: file.type });
};

// Uploads to S3 and returns [{ name, url, type }] ready for the PO documents API.
export const uploadPODocumentFiles = async (prefix, files, type) => {
  const uploaded = await uploadFilesToS3(
    files.map((file, index) => toUniqueUploadFile(prefix, file, index))
  );
  return uploaded.map((file, index) => ({ name: files[index].name, url: file.url, type }));
};
